import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query"

import { invalidationIntents, queryKeys } from "~/api/cache"

import type {
  UpdateProposalConsumptionDto,
  UpdateProposalConsumptionResponseDto,
} from "../dto/proposal-consumption.dto"
import { proposalConsumptionService } from "../services/proposal-consumption.service"

export type UpdateProposalConsumptionSelectionVariables = {
  proposalId: string
  data: UpdateProposalConsumptionDto
  requestId: string
}

export default function useUpdateProposalConsumptionSelection(): UseMutationResult<
  UpdateProposalConsumptionResponseDto,
  unknown,
  UpdateProposalConsumptionSelectionVariables
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      proposalId,
      data,
      requestId,
    }: UpdateProposalConsumptionSelectionVariables) =>
      proposalConsumptionService.updateSelection(proposalId, data, requestId),
    onSuccess: (data, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.proposalConsumption.selection(proposalId),
        data,
      )
      void queryClient.invalidateQueries({
        queryKey: queryKeys.proposalConsumption.insights(proposalId),
      })
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.byId(proposalId),
      })
      void invalidationIntents.proposalPricingInputsChanged(
        queryClient,
        proposalId,
      )
    },
  })
}
